import { FC, PropsWithChildren, useMemo, useState } from "react";

import { WizardDataFormContext } from "./WizardDataFormContext";

export const WizardDataFormProvider: FC<PropsWithChildren> = ({ children }) => {

    const [canShowConfirmIssue, setCanShowConfirmIssue] = useState<boolean>(false);
    const [showSecondaryButton, setShowSecondaryButton] = useState<boolean>(false);

    const values = useMemo(() => ({
        canShowConfirmIssue, 
        setCanShowConfirmIssue,
        showSecondaryButton, 
        setShowSecondaryButton
    }), [
        canShowConfirmIssue, 
        setCanShowConfirmIssue,
        showSecondaryButton, 
        setShowSecondaryButton
    ]);

    return (
        <WizardDataFormContext.Provider value={ values }>              
            { children }
        </WizardDataFormContext.Provider>
    )
}